import { commentItems } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">瓜友热评</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            来看看其他吃瓜群众怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-[960px] mx-auto">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 text-xs"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      {item.likes}
                    </span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}